import TransferActivityView from "@features/tools/view/transfer-activity-view";

const TransferActivity = () => {
  return <TransferActivityView />;
};

export default TransferActivity;
